export default {
  title: 'Obchod s událostmi',
  productPage: 'Stránka produktu',
  qty: 'Množství.',
  button: {
    edit: 'Upravit',
    add: 'Pøidat do košíku',
  },
};
